// extracted by mini-css-extract-plugin
export var container = "_52-0";
export var infoButton = "_52-1";
export var label = "_52-3";
export var labelExpanded = "_52-4";
export var price = "_52-5";
export var priceExpanded = "_52-6";
export var title = "_52-2";